var _module = require('./index');

_module.factory('sliderConfig', function() {    
    return {
        draggable: true,
        enableDrag: function() {
            this.draggable = true;
        },
        disableDrag: function() {
            this.draggable = false;
        }
    };
});
